export default "__VITE_ASSET__DMKxLlT___"